import React from 'react';

import { ArrowDown } from '@travel/icons/ui';
import { IconTextTag } from '@travel/ui';

import styles from './planSkeleton.module.scss';

type Props = {
  isPc: boolean;
  isFirst?: boolean;
};

const PlanSkeleton = (props: Props) => {
  const { isPc, isFirst } = props;
  return (
    <div className={styles.container}>
      <div className={styles.mediaSkeleton} />
      <div className={styles.planInformation}>
        <div className={styles.mainInformation}>
          <IconTextTag haveBorder isEmpty className={styles.tag} />
          {isPc && (
            <>
              <IconTextTag haveBorder isEmpty className={styles.tag} />
              <IconTextTag haveBorder isEmpty className={styles.tag} />
            </>
          )}
          <div className={styles.planSkeleton} />
        </div>
        {isPc && <div className={styles.pcImage} />}
      </div>
      {isFirst && (
        <div className={styles.planInformation}>
          <div className={styles.mainInformation}>
            <IconTextTag haveBorder isEmpty className={styles.tag} />
            {isPc && (
              <>
                <IconTextTag haveBorder isEmpty className={styles.tag} />
                <IconTextTag haveBorder isEmpty className={styles.tag} />
              </>
            )}
            <div className={styles.planSkeleton} />
          </div>
          {isPc && <div className={styles.pcImage} />}
        </div>
      )}
      {!isPc && (
        <div className={styles.planExpand}>
          <ArrowDown color="pastelGray" size={20} className={styles.iconArrow} />
        </div>
      )}
    </div>
  );
};

export default PlanSkeleton;
